export default __webpack_public_path__ + "static/media/rotate_white.2d5cf15c.svg";